/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileWma = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586v3.44h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="m9.451 15.683.703-2.426h.697l.731 2.397.553-2.613h.83l-.868 3.922h-.81l-.804-2.64-.76 2.64h-.809l-.87-3.922h.853zm6.117-.058 1.23-2.584h.879v3.922h-.831v-2.541l-1.035 2.163h-.519l-1.035-2.127v2.505h-.816V13.04h.88zm6.332 1.338h-.94l-.259-.804h-1.447l-.257.804h-.9l1.489-3.922h.814zm-2.419-1.516h.99l-.497-1.54z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileWma as FileWma };
